export const timeZones = [
  {
    "timezone": "Africa/Abidjan",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Africa/Accra",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Africa/Addis_Ababa",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Africa/Algiers",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/Asmara",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Africa/Asmera",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Africa/Bamako",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Africa/Bangui",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/Banjul",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Africa/Bissau",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Africa/Blantyre",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Brazzaville",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/Bujumbura",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Cairo",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Africa/Casablanca",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/Ceuta",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Conakry",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Africa/Dakar",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Africa/Dar_es_Salaam",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Africa/Djibouti",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Africa/Douala",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/El_Aaiun",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/Freetown",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Africa/Gaborone",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Harare",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Johannesburg",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Juba",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Kampala",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Africa/Khartoum",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Kigali",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Kinshasa",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/Lagos",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/Libreville",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/Lome",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Africa/Luanda",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/Lubumbashi",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Lusaka",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Malabo",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/Maputo",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Maseru",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Mbabane",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Mogadishu",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Africa/Monrovia",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Africa/Nairobi",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Africa/Ndjamena",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/Niamey",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/Nouakchott",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Africa/Ouagadougou",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Africa/Porto-Novo",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/Sao_Tome",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Africa/Timbuktu",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Africa/Tripoli",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Africa/Tunis",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Africa/Windhoek",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "America/Adak",
    "offset": "UTC -9:00"
  },
  {
    "timezone": "America/Anchorage",
    "offset": "UTC -8:00"
  },
  {
    "timezone": "America/Anguilla",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Antigua",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Araguaina",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Argentina/Buenos_Aires",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Argentina/Catamarca",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Argentina/ComodRivadavia",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Argentina/Cordoba",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Argentina/Jujuy",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Argentina/La_Rioja",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Argentina/Mendoza",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Argentina/Rio_Gallegos",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Argentina/Salta",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Argentina/San_Juan",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Argentina/San_Luis",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Argentina/Tucuman",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Argentina/Ushuaia",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Aruba",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Asuncion",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Atikokan",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Atka",
    "offset": "UTC -9:00"
  },
  {
    "timezone": "America/Bahia",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Bahia_Banderas",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Barbados",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Belem",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Belize",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Blanc-Sablon",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Boa_Vista",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Bogota",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Boise",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Buenos_Aires",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Cambridge_Bay",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Campo_Grande",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Cancun",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Caracas",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Catamarca",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Cayenne",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Cayman",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Chicago",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Chihuahua",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Ciudad_Juarez",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Coral_Harbour",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Cordoba",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Costa_Rica",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Coyhaique",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Creston",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "America/Cuiaba",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Curacao",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Danmarkshavn",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "America/Dawson",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "America/Dawson_Creek",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "America/Denver",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Detroit",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Dominica",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Edmonton",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Eirunepe",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/El_Salvador",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Ensenada",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "America/Fort_Nelson",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "America/Fort_Wayne",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Fortaleza",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Glace_Bay",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Godthab",
    "offset": "UTC -1:00"
  },
  {
    "timezone": "America/Goose_Bay",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Grand_Turk",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Grenada",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Guadeloupe",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Guatemala",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Guayaquil",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Guyana",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Halifax",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Havana",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Hermosillo",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "America/Indiana/Indianapolis",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Indiana/Knox",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Indiana/Marengo",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Indiana/Petersburg",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Indiana/Tell_City",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Indiana/Vevay",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Indiana/Vincennes",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Indiana/Winamac",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Indianapolis",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Inuvik",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Iqaluit",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Jamaica",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Jujuy",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Juneau",
    "offset": "UTC -8:00"
  },
  {
    "timezone": "America/Kentucky/Louisville",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Kentucky/Monticello",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Knox_IN",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Kralendijk",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/La_Paz",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Lima",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Los_Angeles",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "America/Louisville",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Lower_Princes",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Maceio",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Managua",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Manaus",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Marigot",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Martinique",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Matamoros",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Mazatlan",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "America/Mendoza",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Menominee",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Merida",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Metlakatla",
    "offset": "UTC -8:00"
  },
  {
    "timezone": "America/Mexico_City",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Miquelon",
    "offset": "UTC -2:00"
  },
  {
    "timezone": "America/Moncton",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Monterrey",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Montevideo",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Montreal",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Montserrat",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Nassau",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/New_York",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Nipigon",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Nome",
    "offset": "UTC -8:00"
  },
  {
    "timezone": "America/Noronha",
    "offset": "UTC -2:00"
  },
  {
    "timezone": "America/North_Dakota/Beulah",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/North_Dakota/Center",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/North_Dakota/New_Salem",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Nuuk",
    "offset": "UTC -1:00"
  },
  {
    "timezone": "America/Ojinaga",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Panama",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Pangnirtung",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Paramaribo",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Phoenix",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "America/Port-au-Prince",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Port_of_Spain",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Porto_Acre",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Porto_Velho",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Puerto_Rico",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Punta_Arenas",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Rainy_River",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Rankin_Inlet",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Recife",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Regina",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Resolute",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Rio_Branco",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Rosario",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Santa_Isabel",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "America/Santarem",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Santiago",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Santo_Domingo",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Sao_Paulo",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Scoresbysund",
    "offset": "UTC -1:00"
  },
  {
    "timezone": "America/Shiprock",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Sitka",
    "offset": "UTC -8:00"
  },
  {
    "timezone": "America/St_Barthelemy",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/St_Johns",
    "offset": "UTC -3:30"
  },
  {
    "timezone": "America/St_Kitts",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/St_Lucia",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/St_Thomas",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/St_Vincent",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Swift_Current",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Tegucigalpa",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "America/Thule",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "America/Thunder_Bay",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Tijuana",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "America/Toronto",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Tortola",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Vancouver",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "America/Virgin",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "America/Whitehorse",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "America/Winnipeg",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "America/Yakutat",
    "offset": "UTC -8:00"
  },
  {
    "timezone": "America/Yellowknife",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "Antarctica/Casey",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Antarctica/Davis",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Antarctica/DumontDUrville",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Antarctica/Macquarie",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Antarctica/Mawson",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Antarctica/McMurdo",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Antarctica/Palmer",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "Antarctica/Rothera",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "Antarctica/South_Pole",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Antarctica/Syowa",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Antarctica/Troll",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Antarctica/Vostok",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Arctic/Longyearbyen",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Asia/Aden",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Almaty",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Asia/Amman",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Anadyr",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Asia/Aqtau",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Asia/Aqtobe",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Asia/Ashgabat",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Asia/Ashkhabad",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Asia/Atyrau",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Asia/Baghdad",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Bahrain",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Baku",
    "offset": "UTC +04:00"
  },
  {
    "timezone": "Asia/Bangkok",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Asia/Barnaul",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Asia/Beirut",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Bishkek",
    "offset": "UTC +06:00"
  },
  {
    "timezone": "Asia/Brunei",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Calcutta",
    "offset": "UTC +05:30"
  },
  {
    "timezone": "Asia/Chita",
    "offset": "UTC +09:00"
  },
  {
    "timezone": "Asia/Choibalsan",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Chongqing",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Chungking",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Colombo",
    "offset": "UTC +05:30"
  },
  {
    "timezone": "Asia/Dacca",
    "offset": "UTC +06:00"
  },
  {
    "timezone": "Asia/Damascus",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Dhaka",
    "offset": "UTC +06:00"
  },
  {
    "timezone": "Asia/Dili",
    "offset": "UTC +09:00"
  },
  {
    "timezone": "Asia/Dubai",
    "offset": "UTC +04:00"
  },
  {
    "timezone": "Asia/Dushanbe",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Asia/Famagusta",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Gaza",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Harbin",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Hebron",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Ho_Chi_Minh",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Asia/Hong_Kong",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Hovd",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Asia/Irkutsk",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Istanbul",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Jakarta",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Asia/Jayapura",
    "offset": "UTC +09:00"
  },
  {
    "timezone": "Asia/Jerusalem",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Kabul",
    "offset": "UTC +04:30"
  },
  {
    "timezone": "Asia/Kamchatka",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Asia/Karachi",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Asia/Kashgar",
    "offset": "UTC +06:00"
  },
  {
    "timezone": "Asia/Kathmandu",
    "offset": "UTC +05:45"
  },
  {
    "timezone": "Asia/Katmandu",
    "offset": "UTC +05:45"
  },
  {
    "timezone": "Asia/Khandyga",
    "offset": "UTC +09:00"
  },
  {
    "timezone": "Asia/Kolkata",
    "offset": "UTC +05:30"
  },
  {
    "timezone": "Asia/Krasnoyarsk",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Asia/Kuala_Lumpur",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Kuching",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Kuwait",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Macao",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Macau",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Magadan",
    "offset": "UTC +11:00"
  },
  {
    "timezone": "Asia/Makassar",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Manila",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Muscat",
    "offset": "UTC +04:00"
  },
  {
    "timezone": "Asia/Nicosia",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Novokuznetsk",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Asia/Novosibirsk",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Asia/Omsk",
    "offset": "UTC +06:00"
  },
  {
    "timezone": "Asia/Oral",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Asia/Phnom_Penh",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Asia/Pontianak",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Asia/Pyongyang",
    "offset": "UTC +09:00"
  },
  {
    "timezone": "Asia/Qatar",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Qostanay",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Asia/Qyzylorda",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Asia/Rangoon",
    "offset": "UTC +06:30"
  },
  {
    "timezone": "Asia/Riyadh",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Saigon",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Asia/Sakhalin",
    "offset": "UTC +11:00"
  },
  {
    "timezone": "Asia/Samarkand",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Asia/Seoul",
    "offset": "UTC +09:00"
  },
  {
    "timezone": "Asia/Shanghai",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Singapore",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Srednekolymsk",
    "offset": "UTC +11:00"
  },
  {
    "timezone": "Asia/Taipei",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Tashkent",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Asia/Tbilisi",
    "offset": "UTC +04:00"
  },
  {
    "timezone": "Asia/Tehran",
    "offset": "UTC +03:30"
  },
  {
    "timezone": "Asia/Tel_Aviv",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Asia/Thimbu",
    "offset": "UTC +06:00"
  },
  {
    "timezone": "Asia/Thimphu",
    "offset": "UTC +06:00"
  },
  {
    "timezone": "Asia/Tokyo",
    "offset": "UTC +09:00"
  },
  {
    "timezone": "Asia/Tomsk",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Asia/Ujung_Pandang",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Ulaanbaatar",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Ulan_Bator",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Asia/Urumqi",
    "offset": "UTC +06:00"
  },
  {
    "timezone": "Asia/Ust-Nera",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Asia/Vientiane",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Asia/Vladivostok",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Asia/Yakutsk",
    "offset": "UTC +09:00"
  },
  {
    "timezone": "Asia/Yangon",
    "offset": "UTC +06:30"
  },
  {
    "timezone": "Asia/Yekaterinburg",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Asia/Yerevan",
    "offset": "UTC +04:00"
  },
  {
    "timezone": "Atlantic/Azores",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Atlantic/Bermuda",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "Atlantic/Canary",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Atlantic/Cape_Verde",
    "offset": "UTC -1:00"
  },
  {
    "timezone": "Atlantic/Faeroe",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Atlantic/Faroe",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Atlantic/Jan_Mayen",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Atlantic/Madeira",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Atlantic/Reykjavik",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Atlantic/South_Georgia",
    "offset": "UTC -2:00"
  },
  {
    "timezone": "Atlantic/St_Helena",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Atlantic/Stanley",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "Australia/ACT",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Australia/Adelaide",
    "offset": "UTC +09:30"
  },
  {
    "timezone": "Australia/Brisbane",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Australia/Broken_Hill",
    "offset": "UTC +09:30"
  },
  {
    "timezone": "Australia/Canberra",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Australia/Currie",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Australia/Darwin",
    "offset": "UTC +09:30"
  },
  {
    "timezone": "Australia/Eucla",
    "offset": "UTC +08:45"
  },
  {
    "timezone": "Australia/Hobart",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Australia/LHI",
    "offset": "UTC +10:30"
  },
  {
    "timezone": "Australia/Lindeman",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Australia/Lord_Howe",
    "offset": "UTC +10:30"
  },
  {
    "timezone": "Australia/Melbourne",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Australia/NSW",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Australia/North",
    "offset": "UTC +09:30"
  },
  {
    "timezone": "Australia/Perth",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Australia/Queensland",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Australia/South",
    "offset": "UTC +09:30"
  },
  {
    "timezone": "Australia/Sydney",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Australia/Tasmania",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Australia/Victoria",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Australia/West",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Australia/Yancowinna",
    "offset": "UTC +09:30"
  },
  {
    "timezone": "Brazil/Acre",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "Brazil/DeNoronha",
    "offset": "UTC -2:00"
  },
  {
    "timezone": "Brazil/East",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "Brazil/West",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "CET",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "CST6CDT",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "Canada/Atlantic",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "Canada/Central",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "Canada/Eastern",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "Canada/Mountain",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "Canada/Newfoundland",
    "offset": "UTC -3:30"
  },
  {
    "timezone": "Canada/Pacific",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "Canada/Saskatchewan",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "Canada/Yukon",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "Chile/Continental",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "Chile/EasterIsland",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "Cuba",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "EET",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "EST",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "EST5EDT",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "Egypt",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Eire",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Etc/GMT",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Etc/GMT+0",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Etc/GMT+1",
    "offset": "UTC -1:00"
  },
  {
    "timezone": "Etc/GMT+10",
    "offset": "UTC -10:00"
  },
  {
    "timezone": "Etc/GMT+11",
    "offset": "UTC -11:00"
  },
  {
    "timezone": "Etc/GMT+12",
    "offset": "UTC -12:00"
  },
  {
    "timezone": "Etc/GMT+2",
    "offset": "UTC -2:00"
  },
  {
    "timezone": "Etc/GMT+3",
    "offset": "UTC -3:00"
  },
  {
    "timezone": "Etc/GMT+4",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "Etc/GMT+5",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "Etc/GMT+6",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "Etc/GMT+7",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "Etc/GMT+8",
    "offset": "UTC -8:00"
  },
  {
    "timezone": "Etc/GMT+9",
    "offset": "UTC -9:00"
  },
  {
    "timezone": "Etc/GMT-0",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Etc/GMT-1",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Etc/GMT-10",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Etc/GMT-11",
    "offset": "UTC +11:00"
  },
  {
    "timezone": "Etc/GMT-12",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Etc/GMT-13",
    "offset": "UTC +13:00"
  },
  {
    "timezone": "Etc/GMT-14",
    "offset": "UTC +14:00"
  },
  {
    "timezone": "Etc/GMT-2",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Etc/GMT-3",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Etc/GMT-4",
    "offset": "UTC +04:00"
  },
  {
    "timezone": "Etc/GMT-5",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Etc/GMT-6",
    "offset": "UTC +06:00"
  },
  {
    "timezone": "Etc/GMT-7",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Etc/GMT-8",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Etc/GMT-9",
    "offset": "UTC +09:00"
  },
  {
    "timezone": "Etc/GMT0",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Etc/Greenwich",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Etc/UCT",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Etc/UTC ",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Etc/Universal",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Etc/Zulu",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Europe/Amsterdam",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Andorra",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Astrakhan",
    "offset": "UTC +04:00"
  },
  {
    "timezone": "Europe/Athens",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Belfast",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Europe/Belgrade",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Berlin",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Bratislava",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Brussels",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Bucharest",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Budapest",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Busingen",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Chisinau",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Copenhagen",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Dublin",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Europe/Gibraltar",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Guernsey",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Europe/Helsinki",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Isle_of_Man",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Europe/Istanbul",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Jersey",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Europe/Kaliningrad",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Kiev",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Kirov",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Kyiv",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Lisbon",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Europe/Ljubljana",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/London",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Europe/Luxembourg",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Madrid",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Malta",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Mariehamn",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Minsk",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Monaco",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Moscow",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Nicosia",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Oslo",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Paris",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Podgorica",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Prague",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Riga",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Rome",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Samara",
    "offset": "UTC +04:00"
  },
  {
    "timezone": "Europe/San_Marino",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Sarajevo",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Saratov",
    "offset": "UTC +04:00"
  },
  {
    "timezone": "Europe/Simferopol",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Skopje",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Sofia",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Stockholm",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Tallinn",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Tirane",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Tiraspol",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Ulyanovsk",
    "offset": "UTC +04:00"
  },
  {
    "timezone": "Europe/Uzhgorod",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Vaduz",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Vatican",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Vienna",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Vilnius",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Volgograd",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Warsaw",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Zagreb",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Europe/Zaporozhye",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Europe/Zurich",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "GB",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "GB-Eire",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "GMT",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "GMT+0",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "GMT-0",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "GMT0",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Greenwich",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "HST",
    "offset": "UTC -10:00"
  },
  {
    "timezone": "Hongkong",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Iceland",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Indian/Antananarivo",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Indian/Chagos",
    "offset": "UTC +06:00"
  },
  {
    "timezone": "Indian/Christmas",
    "offset": "UTC +07:00"
  },
  {
    "timezone": "Indian/Cocos",
    "offset": "UTC +06:30"
  },
  {
    "timezone": "Indian/Comoro",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Indian/Kerguelen",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Indian/Mahe",
    "offset": "UTC +04:00"
  },
  {
    "timezone": "Indian/Maldives",
    "offset": "UTC +05:00"
  },
  {
    "timezone": "Indian/Mauritius",
    "offset": "UTC +04:00"
  },
  {
    "timezone": "Indian/Mayotte",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Indian/Reunion",
    "offset": "UTC +04:00"
  },
  {
    "timezone": "Iran",
    "offset": "UTC +03:30"
  },
  {
    "timezone": "Israel",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "Jamaica",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "Japan",
    "offset": "UTC +09:00"
  },
  {
    "timezone": "Kwajalein",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Libya",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "MET",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "MST",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "MST7MDT",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "Mexico/BajaNorte",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "Mexico/BajaSur",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "Mexico/General",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "NZ",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "NZ-CHAT",
    "offset": "UTC +12:45"
  },
  {
    "timezone": "Navajo",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "PRC",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "PST8PDT",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "Pacific/Apia",
    "offset": "UTC +13:00"
  },
  {
    "timezone": "Pacific/Auckland",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Pacific/Bougainville",
    "offset": "UTC +11:00"
  },
  {
    "timezone": "Pacific/Chatham",
    "offset": "UTC +12:45"
  },
  {
    "timezone": "Pacific/Chuuk",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Pacific/Easter",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "Pacific/Efate",
    "offset": "UTC +11:00"
  },
  {
    "timezone": "Pacific/Enderbury",
    "offset": "UTC +13:00"
  },
  {
    "timezone": "Pacific/Fakaofo",
    "offset": "UTC +13:00"
  },
  {
    "timezone": "Pacific/Fiji",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Pacific/Funafuti",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Pacific/Galapagos",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "Pacific/Gambier",
    "offset": "UTC -9:00"
  },
  {
    "timezone": "Pacific/Guadalcanal",
    "offset": "UTC +11:00"
  },
  {
    "timezone": "Pacific/Guam",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Pacific/Honolulu",
    "offset": "UTC -10:00"
  },
  {
    "timezone": "Pacific/Johnston",
    "offset": "UTC -10:00"
  },
  {
    "timezone": "Pacific/Kanton",
    "offset": "UTC +13:00"
  },
  {
    "timezone": "Pacific/Kiritimati",
    "offset": "UTC +14:00"
  },
  {
    "timezone": "Pacific/Kosrae",
    "offset": "UTC +11:00"
  },
  {
    "timezone": "Pacific/Kwajalein",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Pacific/Majuro",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Pacific/Marquesas",
    "offset": "UTC -10:30"
  },
  {
    "timezone": "Pacific/Midway",
    "offset": "UTC -11:00"
  },
  {
    "timezone": "Pacific/Nauru",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Pacific/Niue",
    "offset": "UTC -11:00"
  },
  {
    "timezone": "Pacific/Norfolk",
    "offset": "UTC +11:00"
  },
  {
    "timezone": "Pacific/Noumea",
    "offset": "UTC +11:00"
  },
  {
    "timezone": "Pacific/Pago_Pago",
    "offset": "UTC -11:00"
  },
  {
    "timezone": "Pacific/Palau",
    "offset": "UTC +09:00"
  },
  {
    "timezone": "Pacific/Pitcairn",
    "offset": "UTC -8:00"
  },
  {
    "timezone": "Pacific/Pohnpei",
    "offset": "UTC +11:00"
  },
  {
    "timezone": "Pacific/Ponape",
    "offset": "UTC +11:00"
  },
  {
    "timezone": "Pacific/Port_Moresby",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Pacific/Rarotonga",
    "offset": "UTC -10:00"
  },
  {
    "timezone": "Pacific/Saipan",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Pacific/Samoa",
    "offset": "UTC -11:00"
  },
  {
    "timezone": "Pacific/Tahiti",
    "offset": "UTC -10:00"
  },
  {
    "timezone": "Pacific/Tarawa",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Pacific/Tongatapu",
    "offset": "UTC +13:00"
  },
  {
    "timezone": "Pacific/Truk",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Pacific/Wake",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Pacific/Wallis",
    "offset": "UTC +12:00"
  },
  {
    "timezone": "Pacific/Yap",
    "offset": "UTC +10:00"
  },
  {
    "timezone": "Poland",
    "offset": "UTC +02:00"
  },
  {
    "timezone": "Portugal",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "ROC",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "ROK",
    "offset": "UTC +09:00"
  },
  {
    "timezone": "Singapore",
    "offset": "UTC +08:00"
  },
  {
    "timezone": "Turkey",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "UCT",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "US/Alaska",
    "offset": "UTC -8:00"
  },
  {
    "timezone": "US/Aleutian",
    "offset": "UTC -9:00"
  },
  {
    "timezone": "US/Arizona",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "US/Central",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "US/East-Indiana",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "US/Eastern",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "US/Hawaii",
    "offset": "UTC -10:00"
  },
  {
    "timezone": "US/Indiana-Starke",
    "offset": "UTC -5:00"
  },
  {
    "timezone": "US/Michigan",
    "offset": "UTC -4:00"
  },
  {
    "timezone": "US/Mountain",
    "offset": "UTC -6:00"
  },
  {
    "timezone": "US/Pacific",
    "offset": "UTC -7:00"
  },
  {
    "timezone": "US/Samoa",
    "offset": "UTC -11:00"
  },
  {
    "timezone": "UTC ",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "Universal",
    "offset": "UTC +00:00"
  },
  {
    "timezone": "W-SU",
    "offset": "UTC +03:00"
  },
  {
    "timezone": "WET",
    "offset": "UTC +01:00"
  },
  {
    "timezone": "Zulu",
    "offset": "UTC +00:00"
  }
]